import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config';
import Lara from '@primevue/themes/lara';
// import App from './App.vue'

import componentCalendar from './components/Calendar.vue'
import componentFileBrowser from "@/components/FileBrowser.vue";
import componentFileSelect from "@/components/DrupalElementFileSelect.vue";
import componentTextareaTemplate from "@/components/DrupalElementTextareaTemplate.vue";
import DrupalElementEmailAddresses from "@/components/DrupalElementEmailAddresses.vue";
import {definePreset} from "@primevue/themes";
import ToastService from 'primevue/toastservice';
import ConfirmationService from "primevue/confirmationservice";
import ReportChart from "@/components/ReportChart.vue";

// const app = createApp(App)
//
// app.use(createPinia())
// app.use(ToastService);
// app.use(PrimeVue, {
//   theme: {
//     preset: Lara,
//   }
// });
//
// app.mount('#app')


const MyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#e2f3ff',
      100: '#aad6ff',
      200: '#80c1ff',
      300: '#69baff',
      400: '#2f9efd',
      500: '#008cff',
      600: '#0071d0',
      700: '#005faf',
      800: '#004d8c',
      900: '#00396b',
      950: '#002849'
    }
  }
});

let appOptions = {
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: '.gin--dark-mode',
    },
  }
}

/**
 * Create a new instance of the calendar app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppCalendar = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      componentCalendar,
      {
        // asset_id: tag.dataset.assetId, // Set the 'props' values is the value of the props in the component
        // client_id: tag.dataset.clientId, // Needed when selecting other material
        // activity_id: tag.dataset?.activityId,
        // activity_type: tag.dataset?.activityType,
      }
    )

    // Import libraries
    app.use(createPinia())
    app.use(ToastService);
    app.use(ConfirmationService);

    app.use(PrimeVue, appOptions);

    app.mount(dom_id)
  }
}

// On page load, mount the asset calendar app when the element is already found in the DOM.
const calendarId = "#vue-calendar";
const calendarTag = document.querySelector(calendarId);
if (calendarTag) {
  // Create a new app instance
  window.createAppCalendar(calendarId);
}








/**
 * Create a new instance of the file browser app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppFileBrowser = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      componentFileBrowser,
      {
        // asset_id: tag.dataset.assetId, // Set the 'props' values is the value of the props in the component
        // client_id: tag.dataset.clientId, // Needed when selecting other material
        // activity_id: tag.dataset?.activityId,
        // activity_type: tag.dataset?.activityType,
      }
    )

    // Import libraries
    app.use(createPinia())
    app.use(ToastService);
    app.use(ConfirmationService);

    app.use(PrimeVue, appOptions);

    app.mount(dom_id)
  }
}

// On page load, mount the asset file browser app when the element is already found in the DOM.
const filebrowserId = "#vue-file-browser";
const filebroserTag = document.querySelector(filebrowserId);
if (filebroserTag) {
  // Create a new app instance
  window.createAppFileBrowser(filebrowserId);
}








/**
 * Create a new instance of the file browser app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppDrupalElementFileSelect = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    let fileMaxSize = tag.dataset.fileMaxSize ?? null;
    if (fileMaxSize) {
      // Convert to int
      fileMaxSize = parseInt(fileMaxSize);
    }

    const app = createApp(
      componentFileSelect,
      {
        drupal_input_id: tag.dataset.drupalInputId,
        entity_type: tag.dataset.entityType ?? null,
        bundle: tag.dataset.bundle ?? null,
        field_name: tag.dataset.fieldName ?? null,
        file_allowed_extensions: tag.dataset.fileAllowedExtensions ?? null,
        file_max_size: fileMaxSize,
      }
    )

    // Import libraries
    app.use(createPinia())
    app.use(ToastService);
    app.use(ConfirmationService);

    app.use(PrimeVue, appOptions);

    app.mount(dom_id)
  }
}

// On page load, mount the asset file select app when the element is already found in the DOM.
const fileSelectId = "#vue-file-select";
const fileSelectTag = document.querySelector(fileSelectId);
if (fileSelectTag) {
  // Create a new app instance
  window.createAppDrupalElementFileSelect(fileSelectId);
}








/**
 * Create a new instance of the textarea template app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param tag
 */
window.createAppDrupalElementTextareaTemplate = function(tag) {

  const app = createApp(
    componentTextareaTemplate,
    {
      drupalTextareaId: tag.dataset.drupalTextareaId,
    }
  )

  // Import libraries
  app.use(createPinia())
  app.use(ToastService);
  app.use(ConfirmationService);

  app.use(PrimeVue, appOptions);

  app.mount(tag)

}

// On page load, mount the app when the element is already found in the DOM.
const textareaTemplateClass = ".vue-textarea-template-insert";
const textareaTemplateTag = document.querySelectorAll(textareaTemplateClass);
// Loop over all the textarea template tags and create a new app instance for each.
textareaTemplateTag.forEach((tag) => {
  // Don't create the app when the user is not logged in
  if (!window.drupalSettings.userIsLoggedIn) {
   return;
  }
  // Get the previous sibling. This is the textarea element.
  let $textarea = tag.previousElementSibling;
  // Don't create an app when the textarea element has class 'disable-template-text-insert'
  if ($textarea.classList.contains('disable-template-text-insert')) {
    return;
  }
  // Create a new app instance
  window.createAppDrupalElementTextareaTemplate(tag);
});





/**
 * Create a new instance of the email addresses app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param tag
 */
window.createAppDrupalElementEmailAddressesTemplate = function(tag) {

  const app = createApp(
    DrupalElementEmailAddresses,
    {
      drupalInputId: tag.dataset.drupalInputId,
    }
  )

  // Import libraries
  app.use(createPinia())
  app.use(ToastService);
  app.use(ConfirmationService);

  app.use(PrimeVue, appOptions);

  app.mount(tag)

}

// On page load, mount the app when the element is already found in the DOM.
const emailAddressesClass = ".vue-curiat-email-addresses";
const emailAddressesTag = document.querySelectorAll(emailAddressesClass);
// Loop over all the email addresses tags and create a new app instance for each.
emailAddressesTag.forEach((tag) => {
  // Don't create the app when the user is not logged in
  if (!window.drupalSettings.userIsLoggedIn) {
    return;
  }
  // Create a new app instance
  window.createAppDrupalElementEmailAddressesTemplate(tag);
});



/**
 * Create a new instance of the report chart app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param tag
 */
window.createAppReportChart = function(tag) {

  const app = createApp(
    ReportChart,
    {
      chartType: tag.dataset.chartType ? tag.dataset.chartType : 'bar', // Default to 'bar' chart type
      chartData: tag.dataset.chartData ? JSON.parse(tag.dataset.chartData) : [],
      stacked: tag.dataset.stacked ? tag.dataset.stacked === 'true' : true, // Default to true
    }
  )

  // Import libraries
  app.use(createPinia())
  app.use(ToastService);
  app.use(ConfirmationService);

  app.use(PrimeVue, appOptions);

  app.mount(tag)

}

// On page load, mount the app when the element is already found in the DOM.
const reportChartClass = ".vue-curiat-report-chart";
const reportChartTag = document.querySelectorAll(reportChartClass);
// Loop over all the tags and create a new app instance for each.
reportChartTag.forEach((tag) => {
  // Create a new app instance
  window.createAppReportChart(tag);
});
